import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=11276c71&scoped=true"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=11276c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11276c71",
  null
  
)

export default component.exports